import {CreateDataQueryRequestBody, MotWarningPeriodResponseBody} from '@dms/api/core';

export type VehicleMotCategory = 'expired' | 'expiring';

interface GetVehicleMotDataQueryParams {
  category: VehicleMotCategory;
  period: MotWarningPeriodResponseBody;
  branchIds: string[];
}

const SHARED_FILTERS = {
  saleState: ['for-sale', 'selling'],
  archived: ['0'],
};

export function getVehicleMotDataQuery(
  params: GetVehicleMotDataQueryParams
): CreateDataQueryRequestBody {
  const isExpired = params.category === 'expired';

  return {
    smartSearch: null,
    filters: {
      ...SHARED_FILTERS,
      branch: params.branchIds,
      validUntil: isExpired
        ? {from: null, to: params.period.expiredThrough}
        : {from: params.period.expiringFrom, to: params.period.expiringThrough},
    },
    order: [
      {columnKey: 'validUntil', order: isExpired ? 'DESC' : 'ASC'},
      {columnKey: 'createdAt', order: 'DESC'},
    ],
  };
}
